
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import {
   Checkbox,
   Textbox,
   TextArea,
   MultiSelect,
   DropDownSelect,
   DatePicker,
} from '@/components/formGroups'
import { SchoolStudentDto } from '@ViewModels/SchoolStudentDto'
import {ClassRoomDto} from "@ViewModels/ClassRoomDto";

export default Vue.extend({
   name: 'StudentDetailsForm',
   props: {
      editingItem: Object as () => SchoolStudentDto,
      loading: Boolean,
   },
   data() {
      return {
         classroomOptions: [] as NameValuePair[],
         ethnicityOptions: [] as NameValuePair[],
         targetTypeOptions: [] as NameValuePair[],
         genderOptions: [
            { name: 'Female', value: 'Female' },
            { name: 'Male', value: 'Male' },
         ] as NameValuePair[],
      }
   },
   computed: {
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      userIsSchoolAdmin(): boolean {
         return this.$store.getters.userIsSchoolAdmin
      },
      activeSchoolId(): string {
        return this.$store.getters.activeSchoolId
      },
      activeSchoolYear(): number {
         return this.$store.getters.schoolYearFilter
       },
   },
   mounted() {
      this.loadClassroomOptions()
      this.loadTargetTypeOptions()
      this.loadEthnicityOptions()
   },
   methods: {
      async loadClassroomOptions() {
         const classrooms = await Api.getClassroomsForYear(this.activeSchoolId, this.activeSchoolYear)
         this.classroomOptions = classrooms
            .filter((item: ClassRoomDto) => +item.SchoolYear === +this.activeSchoolYear)
            .map(
                (item: ClassRoomDto) =>
                    ({
                      name: item.Name,
                      value: item.Id,
                    } as NameValuePair)
            )
            .sort((a: NameValuePair, b: NameValuePair) => a.name.localeCompare(b.name))
      },
      async loadTargetTypeOptions() {
         this.targetTypeOptions = await Api.getTargetTypeOptions(this.activeSchoolId)
      },
      async loadEthnicityOptions() {
         this.ethnicityOptions = await Api.getEthnicityOptions(this.activeSchoolId)
      },
   },
   components: {
      Checkbox,
      Textbox,
      TextArea,
      MultiSelect,
      DropDownSelect,
      DatePicker,
   },
})
